<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <group-form :info="info"/>
      </div>
    </div>
  </section>
</template>

<script>
import groupForm from './Temp/GroupFormTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {}
    }
  },
  components: {
    'group-form': groupForm
  },
  methods: {
    getGroupInfo () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroup/' + this.$route.params.group_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.info
        }
      })
    }
  },
  created () {
    this.getGroupInfo()
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpGroup.vue?5e6c9973